import { Divider, Stack } from '@mantine/core';
import { ExtractDataStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import ExtractDataFields from '@/pages/Editor/components/StepSidebar/StepForms/ExtractDataStepForm/ExtractDataFields.tsx';
import ExtractMetadataFields from '@/pages/Editor/components/StepSidebar/StepForms/ExtractDataStepForm/ExtractMetadataFields.tsx';
import MultiDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/MultiDataInputSelector/MultiDataInputSelector.tsx';
import ExtractEntityFields from '@/pages/Editor/components/StepSidebar/StepForms/ExtractDataStepForm/ExtractEntityFields.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';
import ExtractVerificationFields from '@/pages/Editor/components/StepSidebar/StepForms/ExtractDataStepForm/ExtractVerificationFields.tsx';

type props = {
  step: ExtractDataStep;
};

export function ExtractDataForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <Divider mt="xs" mb={'0'} />
      <MultiDataInputSelector step={step} />
      <Divider mt="xs" mb={'0'} />
      <ExtractMetadataFields step={step} />
      <Divider mt="xs" mb={'0'} />
      <ExtractDataFields step={step} />
      <Divider mt="xs" mb={'0'} />
      <ExtractEntityFields step={step} />
      <Divider mt="xs" mb={'0'} />
      <ExtractVerificationFields step={step} />
      <OutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
